import React, { useEffect, useState } from 'react';
import { InputGroup, Modal } from 'react-bootstrap';
import './index.css'
import Button from '@components/common/Button';
import RedInfoIcon from '../../../../assets/svg/exclamation.svg'
import Vectoricon from '../../../../assets/svg/Vector.svg';
import DisabledCalenderIcon from '../../../../assets/svg/DisabledCalender.svg';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { toast } from 'react-toastify';
import endpoints from '@config/endpoints';
import { getData, getDataWithCache, postDataJSON } from '@services/CommonApiService';
import { useDispatch } from 'react-redux';
import { setCheckIsHrp, setIsPregnant, setPregnancyOngoing, setShowPregnancy, setShowServices, updateAncService } from '@store/actions/beneficiaryAction';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { pregnancyClosure,error } from '@constants/ancConstants';
import { getPNCDetails } from '../DeliveryOutcome/constants/DeliveryConstants';
import { benef_const } from '@constants/beneficiaryConstant';
import FormatDate from '@utils/dateFormat';
import { errorLogger } from '@utils/applicationLogUtils';
import { desiredFormatDate } from '@utils/commonUtils';
import { dateFormate } from '@constants/index';
import { useParams } from 'react-router-dom';
import { getLatestServiceAvailedDateByBenefId } from '@services/beneficiaryApiServices';

interface ClosePregnancyProps {
    showModal: boolean;
    handleModalClose: () => any;
}
interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: any,
    compositeId?: any
}
interface formStateType {
    [key: string]: objectTypes
}

const ClosePregnancy: React.FC<ClosePregnancyProps> = ({
    showModal, handleModalClose
}) => {

    useEffect(() => {
        const fetchData = async () => {
            const pregnancyClosureDetails = await getDataWithCache<any>(`${endpoints.getClosureReason}`);
            setReasonData(pregnancyClosureDetails.data);
            const latestAvailedServiceDateRes  = await getLatestServiceAvailedDateByBenefId(benfDetails?.[0]?.benef_id);
            const latestServiceAvailedDate = latestAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef;
            const latestAvailedServiceDateForAbortion = latestServiceAvailedDate ? latestServiceAvailedDate : lmpDate;
            const latestAvailedServiceDateForDelivery = latestServiceAvailedDate ? dayjs(latestServiceAvailedDate) : '';
            setDeliveryOutsideRCHMinDate(latestAvailedServiceDateForDelivery);
            setAbortionOutsideRCHMinDate(dayjs(latestAvailedServiceDateForAbortion));

        }
        fetchData();
    }, [])
    const [isNextClicked, setIsNextClicked] = useState<boolean>(false);
    const [reason, setReason] = useState<string>('');
    const [reasonData, setReasonData] = useState<any>([]);
    const [abortionOutsideRCHMinDate, setAbortionOutsideRCHMinDate] = useState<any>('');
    const [deliveryOutsideRCHMinDate, setDeliveryOutsideRCHMinDate] = useState<any>('');
    const checkIsHRP = useSelector((state: RootState) => state.beneficiary.checkIsHRP);
    const lmpDate = useSelector((state: RootState) => state.beneficiary.currLmpDate);
    const [reasonId, setReasonId] = useState<string>('');
    const { id } = useParams();
    const [dateFormData, setDateFormData] = useState<any>({});
    const [dateForm, setDateForm] = useState<formStateType>({
        dateOfDelivery: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        }
    });
    const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);
    const pregnancyId = useSelector((state: RootState) => state.beneficiary.currPregnancyId);
    const userId = localStorage.getItem('userId');
    const dispatch = useDispatch();

    const handleSubmit = async () => {
        const pncDetails = getPNCDetails(dateForm.dateOfDelivery.value);

        const payload = {
            beneficiaryId: benfDetails[0]?.benef_id,
            pregNancyId: pregnancyId,
            isDeliveryOutsideRCH: reason === benef_const.deliveryOutsideRCH ? true : false,
            isAbortionOutsideRCH: reason === benef_const.abortionOutsideRCH ? true : false,
            parentUserId: userId,
            closureReason: reasonId,
            closureDate: new Date(dateForm.dateOfDelivery.value).getFullYear() + '-' + String(new Date(dateForm.dateOfDelivery.value).getMonth() + 1).padStart(2, '0') + '-' + String(new Date(dateForm.dateOfDelivery.value).getDate()).padStart(2, '0'),
            pncOneStartDate:pncDetails[0].startDate,
            pncOneEndDate:pncDetails[0].endDate,
            pncTwoStartDate:pncDetails[1].startDate,
            pncTwoEndDate:pncDetails[1].endDate,
            pncThreeStartDate:pncDetails[2].startDate,
            pncThreeEndDate:pncDetails[2].endDate,
            pncFourStartDate:pncDetails[3].startDate,
            pncFourEndDate:pncDetails[3].endDate,
            pncFiveStartDate:pncDetails[4].startDate,
            pncFiveEndDate:pncDetails[4].endDate,
            pncSixStartDate:pncDetails[5].startDate,
            pncSixEndDate:pncDetails[5].endDate,
            pncSevenStartDate:pncDetails[6]?.startDate,
            pncSevenEndDate:pncDetails[6]?.endDate,
            processChannel: 'web'
        }
        try {
            const res = await postDataJSON(endpoints.createPregnancyClosure, payload);
            if (res.data) {
                toast.success(pregnancyClosure.success, {
                    position: "top-center"
                });
                handleModalClose()
                dispatch(setShowPregnancy(false));
                dispatch(setShowServices(false));
                dispatch(setPregnancyOngoing(false));
                dispatch(setCheckIsHrp(!checkIsHRP));
                dispatch(updateAncService("viewPregnancyDetails",[]));
                dispatch(setIsPregnant(false))
            }
            else {
                toast.error(error.errorMessage, {
                    position: "top-center"
                });
            }
        }
        catch (e) {
            toast.error(error.errorMessage, {
                position: "top-center"
            });
        }
    }

    const handleChange: any = async (value: any | boolean, key: string, option?: any, id?: any, code?: any) => {
        setDateForm((prevState: any) => ({
            ...prevState,
            ['dateOfDelivery']: {
                ...prevState['dateOfDelivery'],
                value: value,
                isError: false,
                message: '',
                id: option,
                code: code
            },
        }))
    }
    return (
        <div className="pregnancy-closure-modal">
            <Modal
                show={showModal}
                onHide={() => { handleModalClose() }}
                dialogClassName={'pregnancy-closure-modal'}
                centered={true}
                backdrop="static"
            >
                <Modal.Header>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: "445px" }}>
                        <div className="d-flex align-items-center beneficiary_back_button" onClick={() => isNextClicked ? setIsNextClicked(false) : handleModalClose()}>
                            <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                            <span className="ms-1">Back</span>
                        </div>
                        <div className="d-flex align-items-center beneficiary_discard_button" onClick={() => handleModalClose()}>
                            <span className="me-0">Discard</span>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body  >
                    <div className='pregnancy-closure'>
                        <div className="pregnancy-closure-modal-info">
                            {!isNextClicked &&
                                <div className='next-page'>
                                    <div className="pregnancy-closure-radio-button">
                                        <span className={'option-heading-pregnancy-closure'}>
                                            {'Pregnancy Outcome'}
                                            <span className={`radio_button_name ${'yes'}`}></span>
                                        </span>

                                        <div className="pregnancy_closure radio_button_container">
                                            <div className="buttons">
                                                <div>
                                                    <label htmlFor={'option1'} className='option-data'>
                                                        <input
                                                            className={'styled-radio'}
                                                            type="radio"
                                                            disabled={dayjs(lmpDate).add(147, 'day').isAfter(dayjs())}
                                                            onChange={() => {
                                                                setReason(benef_const.deliveryOutsideRCH)
                                                                const id = reasonData.find((item: any) => item.pregnancy_closure_reason_name === 'Is Delivery outside JANANI');
                                                                setReasonId(id.pregnancy_closure_reason_id)
                                                                setDateFormData({
                                                                    '#title': 'Delivery Date',
                                                                    '#minDate': deliveryOutsideRCHMinDate || dayjs(lmpDate).add(147, 'day'),
                                                                })
                                                                setDateForm((prevState: any) => ({
                                                                    ...prevState,
                                                                    ['dateOfDelivery']: {
                                                                        ...prevState['dateOfDelivery'],
                                                                        value: '',
                                                                    },
                                                                }))

                                                            }}
                                                            name={'pregClosure'}
                                                            value={reason}
                                                            defaultChecked={reason===benef_const.deliveryOutsideRCH?true:false}
                                                            id={''}
                                                        />
                                                        <span>{benef_const.deliveryOutsideRCH}</span>
                                                    </label>
                                                </div>
                                                <div>
                                                    <label htmlFor={'option2'} className='option-data'>
                                                        <input
                                                            className={'styled-radio'}
                                                            type="radio"
                                                            disabled={false}
                                                            onChange={() => {
                                                                setReason(benef_const.abortionOutsideRCH)
                                                                const id = reasonData.find((item: any) => item.pregnancy_closure_reason_name === 'Is Abortion outside JANANI');
                                                                setReasonId(id.pregnancy_closure_reason_id)
                                                                setDateFormData({
                                                                    '#title': 'Abortion Date',
                                                                    '#minDate': abortionOutsideRCHMinDate ,
                                                                })
                                                                setDateForm((prevState: any) => ({
                                                                    ...prevState,
                                                                    ['dateOfDelivery']: {
                                                                        ...prevState['dateOfDelivery'],
                                                                        value: '',
                                                                    },
                                                                }))
                                                            }}
                                                            name={'pregClosure'}
                                                            value={reason}
                                                            defaultChecked={reason===benef_const.abortionOutsideRCH?true:false}
                                                            id={''}
                                                        />
                                                        {benef_const.abortionOutsideRCH}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {reason && <div>
                                        <div className={`input-field-container`}>
                                            {dateFormData['#title'] && (
                                                <label
                                                    className={`label-name-from-parent-closure ${true && 'yes'} ${false}`}
                                                >
                                                    {dateFormData['#title']}
                                                </label>
                                            )}
                                            <InputGroup
                                            >
                                                <DatePicker
                                                    format={'DD-MM-YYYY'}
                                                    placeholder={'DD-MM-YYYY'}
                                                    minDate={dateFormData['#minDate']}
                                                    maxDate={dayjs(dayjs().format('YYYY-MM-DD'))}
                                                    value={dateForm.dateOfDelivery.value ? dayjs(dateForm.dateOfDelivery.value) : undefined}
                                                    disabled={false}
                                                    className="dateOfDelivery"
                                                    popupClassName="date-picker-popup"
                                                    onChange={handleChange}
                                                    suffixIcon={<Vectoricon />}
                                                    showTime={false}
                                                    picker="date"
                                                />

                                            </InputGroup>
                                        </div>
                                    </div>}

                                    <div className="aadhar-submit">
                                        <Button
                                            onClick={() => { setIsNextClicked(true) }}
                                            disabled={(reason && dateForm.dateOfDelivery.value) ? false : true}
                                            id="aadhar-beneficiary-submit"
                                            buttonName={'Next'}
                                            colorType={'primary'}
                                            icon={''}
                                            iconPosition={''} /></div> </div>
                            }
                            {isNextClicked &&
                                <div className='next-page'>
                                    <RedInfoIcon className='exclam-icon' />
                                    <span className='closure-heading'>Pregnancy Closure</span>
                                    <span className='consent-data'>This will result in permanent closure of ongoing pregnancy you may not be able to make any changes further in tracking</span>
                                    <div className="aadhar-submit">
                                        <Button
                                            onClick={() => { handleSubmit() }}
                                            disabled={false}
                                            id="aadhar-beneficiary-submit"
                                            buttonName={'Submit'}
                                            colorType={'primary'}
                                            icon={''}
                                            iconPosition={''} /></div>
                                </div>}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>);
};

export default ClosePregnancy;